import { resolvePageObjectMaskSource } from '@sosocio/tools/page-object-mask';
import brush from '../../img/masks/brush.svg';
import cloud from '../../img/masks/cloud.svg';
import clover from '../../img/masks/clover.svg';
import diamond from '../../img/masks/diamond.svg';
import flower from '../../img/masks/flower.svg';
import heart from '../../img/masks/heart.svg';
import octagon from '../../img/masks/octagon.svg';
import square from '../../img/masks/square.svg';
import stamp from '../../img/masks/stamp.svg';
import star from '../../img/masks/star.svg';

/*
 * IMPORTANT: When adding SVG masks, make sure the SVG has the properties
 * "preserveAspectRatio: none", "width", and "height" defined
 * Otherwise Firefox will run into problems displaying them
 */

const maskPresets: {
	[key: string]: {
		src: string;
		lockAspectRatio: boolean;
	};
} = {
	brush: {
		src: brush,
		lockAspectRatio: false,
	},
	circle: {
		src: resolvePageObjectMaskSource('circle')!,
		lockAspectRatio: false,
	},
	circleLocked: {
		src: resolvePageObjectMaskSource('circleLocked')!,
		lockAspectRatio: true,
	},
	cloud: {
		src: cloud,
		lockAspectRatio: false,
	},
	clover: {
		src: clover,
		lockAspectRatio: true,
	},
	diamond: {
		src: diamond,
		lockAspectRatio: false,
	},
	flower: {
		src: flower,
		lockAspectRatio: true,
	},
	heart: {
		src: heart,
		lockAspectRatio: true,
	},
	octagon: {
		src: octagon,
		lockAspectRatio: false,
	},
	squareLocked: {
		src: square,
		lockAspectRatio: true,
	},
	stamp: {
		src: stamp,
		lockAspectRatio: false,
	},
	star: {
		src: star,
		lockAspectRatio: true,
	},
};

export default maskPresets;
